import { useFormContext } from 'react-hook-form'
import get from 'lodash-es/get'

import { MergeElementProps } from '@/lib/core/interfaces/common.types'
import {
  FieldError,
  FieldErrorMessage,
  InputWrapper,
  Label,
} from '@/lib/core/components/TextField/TextField.styles'

import { Input } from './TextArea.styles'

export type TextAreaProps = MergeElementProps<
  'textarea',
  {
    displayInline?: boolean
    label?: string
    name: string
  }
>

export const TextArea = ({
  displayInline,
  label,
  name,
  placeholder,
  disabled,
  ...props
}: TextAreaProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const error = get(errors, `${name}.message`)

  return (
    <>
      <Label
        $required={!!label && props.required}
        $disabled={disabled}
        $displayInline={displayInline}
        htmlFor={name}
      >
        {label}
      </Label>
      <InputWrapper>
        <Input
          id={name}
          placeholder={placeholder}
          $hasError={!!error}
          disabled={disabled}
          {...register(name)}
          {...props}
        />
      </InputWrapper>
      <FieldError>
        {error && (
          <FieldErrorMessage $displayInline={displayInline}>
            {error?.message?.toString()}
          </FieldErrorMessage>
        )}
      </FieldError>
    </>
  )
}
